package com.zaurh.mapquizwebsite.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class DailyRewardDO(
    val day: Int,
    val name: String,
    val type: String,
    val amount: Int,
    val itemId: String? = null,
    val image: String? = null,
    val status: String? = null
)

@Serializable
enum class DailyRewardStatus {
    OBTAINED,
    CLAIM,
    LOCKED
}